import React from 'react';
import { Instagram, ExternalLink } from 'lucide-react';

const InstagramFeed = () => {
  const posts = [
    { id: 1, image: "/images/instagram/post1.jpg", caption: "Grooms, this one's for you: Bortex Wedding Open Day, 18 October" },
    { id: 2, image: "/images/instagram/post2.jpg", caption: "Live music, golden hour and the harbour as your backdrop" },
    { id: 3, image: "/images/instagram/post3.jpg", caption: "Flower crowns and fearless beauty, straight from our latest issue" },
    { id: 4, image: "/images/instagram/post4.jpg", caption: "Did you know? Why wedding rings live on the fourth finger" },
    { id: 5, image: "/images/instagram/post5.jpg", caption: "Meet the partners who bring Malta's weddings to life" },
    { id: 6, image: "/images/instagram/post6.jpg", caption: "Tick it off: our new interactive wedding checklist is live" },
  ];

  return (
    <section className="py-24" style={{ backgroundColor: '#FAF9F7' }} data-testid="instagram-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <p
            className="text-base md:text-lg mb-4 italic"
            style={{ fontFamily: '"Playfair Display", serif', color: '#DE92A9' }}
          >
            Follow the journey
          </p>
          <a
            href="https://www.instagram.com/idomagofficial/"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3"
            data-testid="instagram-handle-link"
          >
            <Instagram size={22} style={{ color: '#DE92A9' }} />
            <h2
              className="text-4xl md:text-5xl lg:text-6xl tracking-tight group-hover:opacity-80 transition-opacity"
              style={{ fontFamily: '"Playfair Display", serif', color: '#2C2C2C' }}
            >
              @idomagofficial
            </h2>
          </a>
          <p className="text-base max-w-xl mx-auto leading-relaxed mt-4" style={{ color: '#757B7F' }}>
            Behind the scenes, real weddings, bridal fashion & the latest from Malta's wedding world.
          </p>
        </div>

        {/* Instagram Grid, 3x2 */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {posts.map((post) => (
            <a
              key={post.id}
              href="https://www.instagram.com/idomagofficial/"
              target="_blank"
              rel="noopener noreferrer"
              className="relative group cursor-pointer overflow-hidden rounded-lg aspect-square block"
              data-testid={`instagram-post-${post.id}`}
            >
              <img
                src={post.image}
                alt={post.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              loading="lazy"
              decoding="async"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-400 flex flex-col items-center justify-center">
                <Instagram size={28} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 mb-2" />
                <p className="text-white text-xs text-center px-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 max-w-[180px] leading-relaxed">
                  {post.caption}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Follow CTA */}
        <div className="text-center mt-12">
          <a
            href="https://www.instagram.com/idomagofficial/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm tracking-[0.15em] font-semibold px-8 py-4 border-2 transition-all duration-300 hover:gap-3 group"
            style={{ borderColor: '#DE92A9', color: '#DE92A9' }}
            data-testid="follow-instagram-btn"
          >
            FOLLOW ON INSTAGRAM
            <ExternalLink size={14} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramFeed;
